var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCommonImage = function SvgIcnCommonImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2.9165C2.36929 2.9165 1.25 4.03579 1.25 5.4165V14.5832C1.25 15.9639 2.36929 17.0832 3.75 17.0832H16.25C17.6307 17.0832 18.75 15.9639 18.75 14.5832V5.4165C18.75 4.03579 17.6307 2.9165 16.25 2.9165H3.75ZM12.9167 6.87484C12.9167 7.45009 12.4503 7.9165 11.875 7.9165C11.2997 7.9165 10.8333 7.45009 10.8333 6.87484C10.8333 6.29958 11.2997 5.83317 11.875 5.83317C12.4503 5.83317 12.9167 6.29958 12.9167 6.87484ZM17.9167 13.7498L14.9643 10.7975C14.6388 10.4719 14.1112 10.4719 13.7857 10.7975L12.5094 12.0738L13.4411 13.0195C13.6121 13.193 13.611 13.4721 13.4387 13.6445C13.2655 13.8176 12.9846 13.8176 12.8114 13.6443L8.08929 8.92247C7.76377 8.59694 7.23623 8.59694 6.91071 8.92247L2.08333 13.7498V14.5832C2.08333 15.5037 2.82949 16.2498 3.75 16.2498H16.25C17.1705 16.2498 17.9167 15.5037 17.9167 14.5832V13.7498Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCommonImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-common-image.21659099.svg";
export { ForwardRef as ReactComponent };